import {MAP_TOOLS} from '@explorer/constants';

export const aoiTooltipMap = {
  [MAP_TOOLS.DRAW_LOCKED_CIRCLE]: 'drawTools.aoiTooltips.drawLockedCircle',
  [MAP_TOOLS.DRAW_LOCKED_RECT]: 'drawTools.aoiTooltips.drawLockedRect',
  [MAP_TOOLS.DRAW_POLYGON]: 'drawTools.aoiTooltips.drawPolygon',
  [MAP_TOOLS.DRAW_CIRCLE]: 'drawTools.aoiTooltips.drawCircle',
  [MAP_TOOLS.DRAW_RECT]: 'drawTools.aoiTooltips.drawRect',
  [MAP_TOOLS.EDIT]: 'drawTools.aoiTooltips.drawEdit',
  CLEAR: 'drawTools.aoiTooltips.clear',
};

export const measureTooltipMap = {
  [MAP_TOOLS.DRAW_POLYGON]: 'drawTools.measureTooltips.drawPolygon',
  [MAP_TOOLS.DRAW_LINE]: 'drawTools.measureTooltips.drawLine',
  [MAP_TOOLS.EDIT]: 'drawTools.measureTooltips.drawEdit',
  CLEAR: 'drawTools.measureTooltips.clear',
};
